import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';


export enum SchedulerSecurityRight {
    CanAccess = 7000,
    ManageAppointments = 7001,
    ManageRunSheets = 7002,
    ManageOtherUserResourceGroups = 7073,
    ManageFieldAllocations = 7074,
    ManageOtherUsersViews = 7075,
    CanCreateCustomViews = 7076   ///Manage Custom Views: Create and Share
}

export class SchedulerSecurityModule extends BaseSecurityModule<SchedulerSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.Scheduler,
            [
                { _id: SchedulerSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: SchedulerSecurityRight.ManageAppointments, name: 'Manage Appointments', basic: true },
                { _id: SchedulerSecurityRight.ManageRunSheets, name: 'Manage Run Sheets', basic: true },
                { _id: SchedulerSecurityRight.ManageOtherUserResourceGroups, name: 'Manage Other User Resource Groups', basic: true },
                { _id: SchedulerSecurityRight.ManageFieldAllocations, name: 'Manage Field Allocations', basic: true },


                { _id: SchedulerSecurityRight.CanCreateCustomViews, name: 'Can Create Views', basic: false },
                { _id: SchedulerSecurityRight.ManageOtherUsersViews, name: 'Can Manage Other User Views', basic: false },
            ] as SecurityRight<SchedulerSecurityRight>[]
        );
    }

}
